module.exports = "<div class=\"field-error-view_text\" title=\"{{placeholderText}}\" id=\"{{id}}\">{{placeholderText}}</div>";